import { Flex, Typography } from '@percent/lemonade'
import { FormSectionProps } from './FormSection.types'

export function FormSection({ title, children }: FormSectionProps) {
  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Flex direction="column" gap={8}>
        {children}
      </Flex>
    </>
  )
}
